// The marketing dashboard — the catalog-wide sweep for work that was started and never finished.
//
// Deliberately NOT cached: the whole point of the page is that its queues are current, and every row links
// out to a screen that changes them. A cached slice would send you to fix something already fixed.

const actions = {
  getDashboard() {
    return this._vm.$http.get('marketing/getDashboard').then((r) => r.data);
  }
};

export default {
  namespaced: true,
  actions
};
